export default class GenericError extends Error {
  constructor(errorCode, message = null, details = {}) {
    super(errorCode);

    this.name = 'GenericError';
    this.errorCode = errorCode; // Machine comparable value
    this.message = message; // Human readable reason (IE. Message)
    this.details = details; // Any other details
  }

  toString() {
    const messageMsg = this.message || null;
    const detailsMsg = (Object.keys(this.details).length > 0) ? ` (${JSON.stringify(this.details).split(',').join(';')})` : null;

    return `GenericError: [${this.errorCode}] ${messageMsg || ''} ${detailsMsg || ''}`;
  }
}
